/* eslint-disable eqeqeq */
import { useContext, useState } from 'react';
import CeaseBreadcrumbsItem from './CeaseBreadcrumbsItem';
import { Case } from 'src/common/models/common-types';
import { GlobalContext } from 'src/common/contexts/globalContext';
import { filterCasesById } from '../../../../../Sidebar/components/CasesSidebar/utils';
import { Box, Grid, IconButton, Menu, MenuItem, TextField, Typography } from '@mui/material';
import CaseOptions from '../../../../../Sidebar/components/CasesSidebar/components/CaseTree/components/CaseOptions/CaseOptions';
import { useLocation, useNavigate } from 'react-router-dom';
import { getUrlQuery } from 'src/common/utils/communication';
import { IconFolderOpen, IconFolder, IconArrowRight, IconThreeDotsOptionsHorizontal } from 'src/common/images';
import { usePopup } from '@cellebrite/saas-ui-common';

const iconStyle = {
    marginLeft: '13px',
    marginRight: '13px',
};

const CaseBreadcrumbs = () => {
    const { casesData } = useContext(GlobalContext);
    const [textValue, setTextValue] = useState('');
    const [isEditMode, setIsEditMode] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [open, anchorEl, handleMenuOpen, handleMenuClose] = usePopup();

    const onSetActiveCase = (caseId: string) => {
        const isOnCollectionsPage = location.pathname.includes('collections');
        if (casesData.activeCaseId !== caseId || !isOnCollectionsPage) {
            casesData.setActiveCase(caseId);

            navigate(`/collections${getUrlQuery()}`);
            handleMenuClose();
        }
    };

    const renameActiveCaseMode = (caseName: string) => {
        setTextValue(caseName);
        setIsEditMode(true);
    };

    const onRenameCase = async (caseNode: Case, newName: string) =>
        await casesData.updateCase({
            caseId: caseNode.id,
            caseData: { description: caseNode.description, name: newName },
        });

    const flatenCases = (csNode: Case, casesList: Case[]) => {
        if (!csNode) return;
        casesList.push(csNode);

        if (csNode.id === casesData.activeCaseId) return;

        if (csNode.children.length > 0 && csNode.children[0]) {
            flatenCases(csNode.children[0], casesList);
        }
    };

    const renderBreadcrumbs = (caseId: string) => {
        let casesList: Case[] = [];

        if (casesData.cases && caseId) {
            const casesChain = filterCasesById(JSON.parse(JSON.stringify(casesData.cases)), caseId);
            flatenCases(casesChain[0], casesList);
        }

        if (casesList.length > 3) {
            return (
                <Grid sx={{ ml: '40px' }} container width="100%" alignItems="center">
                    <CeaseBreadcrumbsItem
                        caseItem={casesList[casesList.length - 1]}
                        onCaseClickAction={onSetActiveCase}
                        rootCase
                    />

                    <IconArrowRight className="fill-md" style={iconStyle} />

                    <CeaseBreadcrumbsItem caseItem={casesList[0]} onCaseClickAction={onSetActiveCase} />
                    <IconArrowRight className="fill-md" style={iconStyle} />
                    <IconButton onClick={handleMenuOpen}>
                        <IconThreeDotsOptionsHorizontal className="fill-md" />
                    </IconButton>
                    <IconArrowRight className="fill-md" style={iconStyle} />

                    {isEditMode ? (
                        <Box
                            sx={{
                                ml: 1.5,
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <IconFolderOpen className="fill-ba" />
                            <TextField
                                autoFocus
                                variant="standard"
                                value={textValue}
                                error={textValue.length === 0}
                                sx={{
                                    ml: 1.5,
                                }}
                                onKeyUp={(e) => {
                                    if (e.key == 'Enter') {
                                        if (textValue.length !== 0) {
                                            onRenameCase(casesList[casesList.length - 1], textValue);
                                        }
                                        setIsEditMode(false);
                                    }
                                }}
                                onBlur={() => {
                                    if (textValue.length !== 0) {
                                        onRenameCase(casesList[casesList.length - 1], textValue);
                                    }
                                    setIsEditMode(false);
                                }}
                                onChange={(e) => setTextValue(e.target.value)}
                            />
                        </Box>
                    ) : (
                        <CaseOptions
                            caseNode={casesList[casesList.length - 1]}
                            contextMenu={null}
                            optionsButton={true}
                            renameCaseFn={() => renameActiveCaseMode(casesList[casesList.length - 1].name)}
                        />
                    )}

                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleMenuClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        {casesList.map(
                            (cs) =>
                                cs.id !== casesData.activeCaseId &&
                                cs.id !== casesList[0].id && (
                                    <MenuItem onClick={() => onSetActiveCase(cs.id)} key={cs.id}>
                                        <IconFolder className="fill-md" />{' '}
                                        <Typography sx={{ ml: 1.5 }}>{cs.name}</Typography>
                                    </MenuItem>
                                ),
                        )}
                    </Menu>
                </Grid>
            );
        }

        return (
            <Grid sx={{ ml: '40px' }} container width="100%" alignItems="center">
                <CeaseBreadcrumbsItem
                    caseItem={casesList[casesList.length - 1]}
                    onCaseClickAction={onSetActiveCase}
                    rootCase
                />

                <IconArrowRight className="fill-md" style={iconStyle} />
                {casesList.map((cs) =>
                    cs.id !== casesData.activeCaseId ? (
                        <div key={cs.id} style={{ display: 'contents' }}>
                            <CeaseBreadcrumbsItem caseItem={cs} onCaseClickAction={onSetActiveCase} />
                            <IconArrowRight className="fill-md" style={iconStyle} />
                        </div>
                    ) : (
                        <span key={cs.id}>
                            {isEditMode ? (
                                <Box
                                    sx={{
                                        ml: 1.5,
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    <IconFolderOpen className="fill-ba" />
                                    <TextField
                                        autoFocus
                                        variant="standard"
                                        value={textValue}
                                        error={textValue.length === 0}
                                        sx={{
                                            ml: 1.5,
                                        }}
                                        onKeyUp={(e) => {
                                            if (e.key == 'Enter') {
                                                if (textValue.length !== 0) {
                                                    onRenameCase(cs, textValue);
                                                }
                                                setIsEditMode(false);
                                            }
                                        }}
                                        onBlur={() => {
                                            if (textValue.length !== 0) {
                                                onRenameCase(cs, textValue);
                                            }
                                            setIsEditMode(false);
                                        }}
                                        onChange={(e) => setTextValue(e.target.value)}
                                    />
                                </Box>
                            ) : (
                                <CaseOptions
                                    caseNode={cs}
                                    contextMenu={null}
                                    optionsButton={true}
                                    renameCaseFn={() => renameActiveCaseMode(cs.name)}
                                />
                            )}
                        </span>
                    ),
                )}
            </Grid>
        );
    };

    if (casesData.activeCaseId) return renderBreadcrumbs(casesData.activeCaseId);

    return <Grid container width="100%" alignItems="center" />;
};

export default CaseBreadcrumbs;
